"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = void 0;
var antd_1 = require("antd");
Object.defineProperty(exports, "Skeleton", { enumerable: true, get: function () { return antd_1.Skeleton; } });
